import { useEffect, useReducer, useState } from 'react'
import { Box, Button, Dialog, Grid, IconButton, Select, Stack, MenuItem, TextField, Typography, Alert, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment'

import CloseIcon from '@mui/icons-material/Close';

import useFetch from '../../../api/api'
import CurrencyField from '../../../components/CurrencyField';
import config from '../../../common/Config';

const EditTransactionDialog = (props) => {

	const { open, closeHandler, transaction, setDisplaySuccessAlert, setMessage } = props

	const [displayErrorMessage,	setDisplayErrorMessage] 	= useState(false)
	const [errorMessage, 		setErrorMessage]			= useState()
	const [highlightErrors,	 	setHighlightErrors]			= useState(false)

	const [inputFields, dispatch]							= useReducer(reducer, initialState)
	const privateFetch 										= useFetch()

	useEffect(() => {
		if (transaction) {
			dispatch({
				type : 'load',
				payload : {
					isValid		: true,
					errorList	: [],
					id			: transaction.id,
					ticker		: transaction.stockTicker,
					assetType	: transaction.assetType,
					date 		: moment(transaction.date),
					operation	: transaction.operation,
					quantity	: transaction.quantity,
					total		: transaction.total,
					cost		: transaction.cost
				}
			})
		}
	}, [transaction])

	const handleClose = () => {
		closeHandler()
	}

	const handleSave = () => {
		
		if (inputFields.isValid) {
			privateFetch(config.apiUrl +"/api/transactions", {
				method : "PUT",
				headers : {
					"Content-Type" : "application/json"	
				},
				body : stringify(inputFields)
			})
			.then(data => data.json())
			.then(data => {
				if (data.status === 500) {
					setDisplayErrorMessage(true)
					setErrorMessage('Erro ao atualizar transação: '+ data.message)
				}
				else {
					setHighlightErrors(false)
					setDisplaySuccessAlert(true)
					setMessage('Transação atualizada com sucesso')
					handleClose()
				}
			})
		}
		else {
			setHighlightErrors(true)
			setDisplayErrorMessage(true)
			setErrorMessage('Erro ao atualizar transação: alguns campos não foram preenchidos corretamente!')
		}
	}

	return (
		<Dialog onClose={handleClose} open={open}>

			<Box display={'flex'} sx={{ml: 2, mr: 2, mt: 2, mb: 1}}>
				<Typography variant='h6' flex={1}>Editar transação</Typography>
				<IconButton onClick={handleClose}><CloseIcon/></IconButton>
			</Box>
			{ displayErrorMessage ? <Alert severity="error" onClose={() => {setDisplayErrorMessage(false)}} sx={{mt: 0, ml:2, mr: 2, mb:2}}>{errorMessage}</Alert> : null }	
			<Grid container paddingX={2} paddingBottom={2} spacing={1}>
				<Grid item xs={12}>
					<Stack spacing={1} direction={{xs: 'column', md: 'row'}}>
						<DatePicker 
							format="DD/MM/YYYY" 
							label="Data da Operação" 
							sx={{width: '100%'}}
							value={inputFields.date} 
							onChange={(value) => dispatch({type: 'update', field: 'date', payload : value})} 
							slotProps={{
								textField: {
								variant: 'outlined',
								error: highlightErrors && inputFields.errorList.includes('date'),
								helperText: highlightErrors && inputFields.errorList.includes('date') && 'Uma data precisar ser preenchida!',
								},
							}}
						/>
						<TextField 
							name="name" 
							label="Ticker" 
							value={inputFields.ticker} 
							disabled  
							fullWidth
						/>
						<FormControl 
							error={highlightErrors && inputFields.errorList.includes('operation')}
							fullWidth>
							<InputLabel id="select-operation-label">Operação</InputLabel>
							<Select
								labelId="select-operation-label"
								id="select-operation"
								name="operation"
								value={inputFields.operation}
								label="Operação"
								onChange={e => dispatch({type: 'update', field : 'operation', payload : e.target.value})}
								>
								<MenuItem value={''}>Selecione</MenuItem>
								<MenuItem value={'BUY'}>Compra</MenuItem>
								<MenuItem value={'SELL'}>Venda</MenuItem>
							</Select>
							{highlightErrors && inputFields.errorList.includes('operation') ? (<FormHelperText>Um tipo de operação deve ser especificado</FormHelperText>) : null}
						</FormControl>					
					</Stack>
				</Grid>
				<Grid item xs={12}>
					<Stack spacing={1} direction={{xs: 'column', md: 'row'}}>
						<TextField 
							name="quantity" 
							label="Quantidade" 
							value={inputFields.quantity || 0} 
							onChange={(e) => dispatch({type: 'update', field : 'quantity', payload: e.target.value})}
							error={highlightErrors && inputFields.errorList.includes('quantity')}
							helperText={highlightErrors && inputFields.errorList.includes('quantity') && "Quantidade inválida!"}
						/>
						<CurrencyField 
							name="valor" 
							label="Valor"
							value={inputFields.total}
							onChange={(e) => dispatch({type: 'update', field: 'total', payload: e.target.value})}
							error={highlightErrors && inputFields.errorList.includes('total')}
							helperText={highlightErrors && inputFields.errorList.includes('total') && "Valor inválido!"}							
						/>
						<CurrencyField 
							name="cost" 
							label="Custo" 
							value={inputFields.cost} 
							onChange={(e) => dispatch({type: 'update', field: 'cost', payload: e.target.value})}
							error={highlightErrors && inputFields.errorList.includes('cost')}
							helperText={highlightErrors && inputFields.errorList.includes('cost') && "Custo inválido!"}							
						/>
						<TextField 
							name="name" 
							label="Total" 
							value={'R$ '+ (parseFloat(inputFields.total) + parseFloat(inputFields.cost)).toFixed(2)} 
							disabled
						/>
					</Stack>
				</Grid>
				<Grid item justifySelf={'right'}>
					<Stack spacing={1} direction={'row'} justifyContent={'right'}>
						<Button variant='contained' color='secondary' onClick={handleClose}> Cancelar </Button>
						<Button variant='contained' onClick={handleSave}> Salvar </Button>
					</Stack>					
				</Grid>
			</Grid>
		</Dialog>
	)
}
const initialState = {
	date			: moment(),
	operation		: '',
	quantity		: 0,
	total			: 0, 
	cost			: 0,
	isValid			: true,
	errorList		: []
}

const reducer = (inputFields, action) => {
	let updatedState = {...inputFields}

	switch (action.type) {
		case 'load' : 
			updatedState = action.payload

			break;

		case 'update' :
			updatedState = {
				...updatedState,
				[action.field] : action.payload
			};
			break;
	}

	const [isValid, errorList] = validate(updatedState)
	updatedState.isValid 	= isValid
	updatedState.errorList 	= errorList	
	
	return updatedState;
}

const validate = (inputFields) => {
	let errorFields = []

	if (!inputFields.date || inputFields.date === '' ) 										errorFields.push('date'); 
	if (!inputFields.operation || inputFields.operation === '' )							errorFields.push('operation'); 
	if (parseFloat(inputFields.quantity) === 0 || isNaN(inputFields.quantity))				errorFields.push('quantity');
	if (parseFloat(inputFields.total) === 0 || isNaN(parseFloat(inputFields.total))) 		errorFields.push('total'); 
	if (parseFloat(inputFields.cost) === 0 || isNaN(parseFloat(inputFields.cost))) 			errorFields.push('cost'); 

	return [errorFields.length === 0 ? true : false, errorFields];
}

const stringify = (inputFields) => {
	return JSON.stringify({
		transaction : {
			...inputFields,
			quantity 	: Math.abs(inputFields.quantity) * (inputFields.operation === 'SELL' ? -1 : 1),
			totalPaid	: Math.abs(inputFields.total) * (inputFields.operation === 'SELL' ? -1 : 1),
			cost 		: Math.abs(inputFields.cost) * (inputFields.operation === 'SELL' ? -1 : 1)
		}
	})
}


export default EditTransactionDialog